import React from "react";
import Posts from "./components/Posts"
function App() {
  return (
    <div className="App">
      Hello everyone
      <Posts/>
    </div>
  );
}

export default App;
